import { Component, OnInit } from '@angular/core';
import { FiltersOfConsult } from '@shared/utils/filters-of-consult';

import * as moment from 'moment';
import * as toastr from 'toastr'

import { RetornoGetVendedoresSemAgendamento, GetVendedoresSemAgendamentoParameters, ExportarVendedoresSemAgendamentoParameters, GetVendedoresComAgendamentoParameters } from '../../services/models';
import { UserTypes } from '@shared/enums';
import { User } from '@shared/models';
import { ConsultRequest } from '@shared/utils/consult-request';
import { RequestWithFetchStatus } from '@shared/utils/request-with-fetch-status';
import { Utilservice } from '@core/services/util.service';

import { VisitasService } from '../../services/visitas.service';
import { Filters } from '../vendedor-com-agendamento/vendedor-com-agendamento.component.model';
import { values } from 'lodash';
import { CheckBoxComponent } from '@shared/components/check-box/check-box.component';
import { CheckboxControlValueAccessor } from '@angular/forms';

// import { Filters } from './vendedores-sem-agendamento.component.models';

@Component({
  selector: 'app-vendedor-com-agendamento',
  templateUrl: './vendedor-com-agendamento.component.html',
  styleUrls: ['./vendedor-com-agendamento.component.css']
})
export class VendedorComAgendamentoComponent implements OnInit {

  UserTypes = UserTypes;
  userLogado: User;

  listaSetoresGrid = [];

  filtersOfConsult = new FiltersOfConsult<Filters>({
    setor: null,
    dataInicial: moment().add(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD'),
    dataFinal: moment().add(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD'),
    listSetorSelecionado : [],
  });

  setoresRequest = new ConsultRequest<any[]>();
  constultaRequest = new ConsultRequest<RetornoGetVendedoresSemAgendamento[]>()
  exportRequest = new RequestWithFetchStatus<any>()

  // week = {
  //   start: moment().startOf('isoWeek'),
  //   end: moment().endOf('isoWeek'),
  //   formatedStart: moment().startOf('isoWeek').format('DD/MM/YYYY'),
  //   formatedEnd: moment().endOf('isoWeek').format('DD/MM/YYYY')
  // };

  week = {
    start: moment().add(1, 'weeks').startOf('isoWeek'),
    end: moment().add(1, 'weeks').endOf('isoWeek'),
    formatedStart: moment().add(1, 'weeks').startOf('isoWeek').format('DD/MM/YYYY'),
    formatedEnd: moment().add(1, 'weeks').endOf('isoWeek').format('DD/MM/YYYY')
  };

  constructor(
    private visitService: VisitasService,
  ) { }

  ngOnInit() {
    const user = localStorage.getItem("user_logado");
    this.userLogado = JSON.parse(user);

    this.getSetores()
  }

  onConsultar(){
    const params = this.getParams();

    if(!params) return;

    this.constultaRequest.get(
      this.visitService.getVendedoresComAgendamento(params)
    )

  }

  

  btnAlterarTransmissao(){
    
    const inputsChecked = $('#dvTable table tbody tr').find('input[id^=representanteCheck]:checkbox:checked');
    $.each(inputsChecked, function(index, element){
        console.log(element.textContent);
    })

    for (let i = 0; i < inputsChecked.length; i++) {
      console.log ("Block statement execution no." + inputsChecked[i].textContent);
      // inputsChecked[i].attributes.item
      this.listaSetoresGrid[i] = inputsChecked[i].textContent;

    }

    this.filtersOfConsult.filters.listSetorSelecionado = this.listaSetoresGrid;
    const params = this.getParams();

    if(!params) return;

    this.constultaRequest.get(
      this.visitService.AlterarTransmissaoRepresentante(params)
    )

  }

  resetFilters(){
    this.filtersOfConsult.resetAll()
  }

  handleExport(){
    const params = this.getParams();

    if(!params) return;

    this.exportarVendedoresSemAgendamento(params);
  }

  //metodos privados

  private getSetores(){
    if(this.userLogado.perfil == 2){
      const {idSetor, setor} = this.userLogado;
      const {filters} = this.filtersOfConsult

      filters.setor = {
        id: idSetor,
        codigo: setor,
      }
    }else{
      this.setoresRequest.get(
        this.visitService.getSetores()
      )
    }
  }

  private getParams(){
    const {setor, dataInicial, dataFinal, listSetorSelecionado} = this.filtersOfConsult.filters;

    if(!dataInicial || !dataFinal){
      toastr.error('Período Obrigatório')
      return null;
    }

    const params: GetVendedoresComAgendamentoParameters = {
      dataInicial,
      dataFinal
    }

    if(setor) params.codigoRegional = setor.codigo;

    if(listSetorSelecionado.length == null && listSetorSelecionado.length == 0){
      toastr.error('Selecione um representante para alterar transmissão')
      return null;
    }
    else
    {
      params.listSetorSelecionado = listSetorSelecionado;
    }

   return params;
  }

  private exportarVendedoresSemAgendamento(params: ExportarVendedoresSemAgendamentoParameters){
    this.exportRequest.get(
      this.visitService.exportarVendedoresSemAgendamento(params)
    ).subscribe(
      response => {
        Utilservice.exportToFile(
          response.blob(),
          `exportacao-vendedores-sem-agendamento ${moment().format('DD/MM/YYYY HH:mm:ss')}.xls`
        )
      }
    )
  }

  changeWeek(direction: string): void {
      const currentWeek = this.week;
  
      const date = direction == 'back' ?
        moment(currentWeek.start).subtract(7, 'd') : moment(currentWeek.end).add(1, 'd');
  
      this.week = {
        start: moment(date.startOf('isoWeek')),
        end: moment(date.endOf('isoWeek')),
        formatedStart: date.startOf('isoWeek').format('DD/MM/YYYY'),
        formatedEnd: date.endOf('isoWeek').format('DD/MM/YYYY')
      }
  
      this.filtersOfConsult.filters.dataInicial = date.startOf('isoWeek').format('YYYY-MM-DD');
      this.filtersOfConsult.filters.dataFinal = date.endOf('isoWeek').format('YYYY-MM-DD');
    }

}
